import type { ReactNode } from "react";

import { useT } from "../i18n";
import { useSessao } from "../online/sessao";

/**
 * Os dois pedaços que o saguão e o hub da liga diziam cada um por si.
 *
 * Eles não são a mesma tela e não devem virar uma: a linha de membro do saguão
 * tem título comprado, crachá de comissário, situação, última ação e os botões
 * do comissário, e a do hub é só nome e clube. Forçar um componente só
 * empurraria a tela simples a carregar o que ela não usa.
 *
 * O que é mesmo igual são estas duas coisas, e elas moram aqui por um motivo
 * prático: o verde de "pronto" e o texto de "reconectando" eram escritos duas
 * vezes, e quem trocasse um trocaria metade do jogo.
 */

/**
 * Se o canal ao vivo está de pé.
 *
 * Lê a sessão sozinho em vez de receber por propriedade: as duas telas que
 * mostram isto já estão dentro dela, e passar de mão em mão só criaria caminho
 * para uma delas mostrar o estado de ontem.
 */
export function EstadoDaConexao({ className }: { className?: string }): ReactNode {
  const t = useT();
  const sessao = useSessao();

  return (
    <span
      className={className ?? "label-muted"}
      style={className ? { fontSize: 12, color: "var(--text-muted)" } : undefined}
    >
      {sessao.aoVivo ? t("online.conectado") : t("online.reconectando")}
    </span>
  );
}

/**
 * Se o treinador já decidiu a rodada.
 *
 * Verde quando decidiu, apagado quando não. A cor é o recado: numa lista de
 * oito membros, quem procura sabe quem está segurando a rodada sem ler linha
 * por linha.
 */
export function SituacaoDeDecisao({ pronto }: { pronto: boolean }): ReactNode {
  const t = useT();

  return (
    <span style={{ color: pronto ? "var(--success)" : "var(--text-dim)" }}>
      {pronto ? t("ligas.saguao.pronto") : t("ligas.saguao.semDecisao")}
    </span>
  );
}
